// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import IntersectIntvTime from './components/IntersectIntvTime.vue';
import eventBus from "../../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model;
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.getZeroTime = (val) =>{
                let time = val ? new Date(val) : new Date();
                return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()).getTime();
            }
            new Vue({
                el: model.dom,
                template: '<div :class="className" style="display: flex;flex-direction: column;align-items: stretch!important;flex-grow: 1;flex-shrink: 1"><IntersectIntvTime :invoke="invoke" :className="className" :intverIntersectData="intverIntersectData" :themeNum="themeNum" /></div>',
                components: {
                    IntersectIntvTime
                },
                computed: {
                    className(){
                        return 'intersecIntvTime' + Math.floor(Math.random()*10000)
                    }
                },
                data: {
                    intverIntersectData:{},
                    themeNum:"#5582F3"
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    const self = this
                    if(props.themeNum){
                        this.themeNum = props.themeNum;
                    }
                    if (props.data && props.data.hasOwnProperty('setIntverIntersectData') && props.data.setIntverIntersectData) {
                        this.intverIntersectData = JSON.parse(props.data.setIntverIntersectData);
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){
                            this.themeNum = props.themeNum;
                        }
                        if(!props.data){return}
                        if (props.data.hasOwnProperty('setIntverIntersectData') && props.data.setIntverIntersectData) {
                            this.intverIntersectData = JSON.parse(props.data.setIntverIntersectData);
                        }
                    })
                    console.log(this.intverIntersectData)

                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('intersectIntvTime', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
